__turbopack_context__.v({
  "mapFooter": "CatchMap-module__vAeI6G__mapFooter",
  "mapStill": "CatchMap-module__vAeI6G__mapStill",
});
